
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import { isInWhiteList } from '@/utils/whiteList';

@Component({
  name: 'TitleBar',
})
class TitleBar extends Vue {
  @Prop({ default: '' }) titleName :string|undefined;
  @Prop({ default: 0 }) unReadMsgNum:number|undefined;
  @Prop({ default: false }) isMinify: boolean | undefined;
  @Prop({ default: false }) inIframe: boolean | undefined;
  @Prop({
    default() {
      return {};
    },
  }) wpaDetail: any;

  dragging:boolean = false;
  tLeft:number = 0;
  tTop: number = 0;
  // canChangeMinify :boolean= false;
  changeMinify() {
    const parent:any = this.$parent;
    parent && parent.openIframeIM();
    // if (this.canChangeMinify) {
    //   const parent:any = this.$parent;
    //   parent && (parent.isMinify = false);
    // }
  }
  get titleMsg() {
    // 如果在白名单里，则直接使用默认title
    // if (this.title && !isInWhiteList(this.wpaDetail?.kfuin, 'USE_DEFAULT_TITLE')) {
    // 金茂接受新的方式，去除白名单逻辑。
    if (this.titleName) {
      return this.titleName;
    }
    return this.$t('common_page_title');
  }
  @Watch('titleMsg', { immediate: true })
  onTitleChange(val) {
    const defaultTitle = this.$t('common_page_title').toString();
    if (val === defaultTitle) {
      // 如果是默认标题，就直接显示
      document.title = defaultTitle;
    } else {
      document.title = this.$t('common_chatting_with_text').toString()
        .replace('$1', val);
    }
  }
  closeBtnClick() {
    const parent:any = this.$parent;
    parent && parent.closeIframeIM();
  }


  // drayStart(e) {
  //   this.canChangeMinify = true;
  //   this.dragging = true;
  //   this.tLeft = e.screenX ; // 鼠标按下时和选中元素的坐标偏移:x坐标
  //   this.tTop = e.screenY ; // 鼠标按下时和选中元素的坐标偏移:y坐标
  //   // postMsg.send({
  //   //     act: 'DRAG_START',
  //   //     kfuin: globalVars.receptionist.kfUin
  //   // });
  //   // 监听鼠标放开事件
  //   document.addEventListener('mouseup',  this.drayEnd);
  //   document.addEventListener('mousemove', this.drayMove);
  // }
  // drayEnd() {
  //   this.dragging = false;
  //   // postMsg.send({
  //   //   act: 'DRAG_END',
  //   //   kfuin: globalVars.receptionist.kfUin,
  //   // });
  //   document.removeEventListener('mouseup', this.drayEnd);
  //   document.removeEventListener('mousemove', this.drayMove);
  // }

  // drayMove(e:any) {
  //   if (this.dragging) {
  //     const moveX = e.screenX - this.tLeft;
  //     const moveY = e.screenY - this.tTop;
  //     console.log('moveX', moveX, moveY);
  //     if (Math.abs(moveX) + Math.abs(moveY) > 5) {
  //       this.canChangeMinify = false;
  //     }
  //     // postMsg.send({
  //     //   act: 'DRAG_MOVE',
  //     //   kfuin: globalVars.receptionist.kfUin,
  //     //   data: {
  //     //     x: moveX,
  //     //     y: moveY,
  //     //   },
  //     // });
  //   }
  // }
}
export default TitleBar;
